import React from 'react';
import { Controller, type Control } from 'react-hook-form';
import { DatePicker, Label } from '@shared/components';
import { dateKeyToLocalDate, toDateKey } from '@features/quote/utils/dateKey';
import type {
    SmriqPlanFormInput,
    SmriqPlanFormOutput,
} from '../../../../schemas/smriqJourney.schema';

interface PlanStartDateFieldProps {
    control: Control<SmriqPlanFormInput, unknown, SmriqPlanFormOutput>;
    disabled: boolean;
    onFieldsChange: () => void;
    onPlanStartDateChange?: (date: string) => void;
}

export const PlanStartDateField: React.FC<PlanStartDateFieldProps> = ({
    control,
    disabled,
    onFieldsChange,
    onPlanStartDateChange,
}) => (
    <div>
        <Label htmlFor="smriq_plan_start_date" required>
            Plan Start Date
        </Label>
        <Controller
            name="plan_start_date"
            control={control}
            render={({ field, fieldState: { error } }) => (
                <DatePicker
                    id="smriq_plan_start_date"
                    ariaLabel="Plan Start Date"
                    value={dateKeyToLocalDate(field.value) ?? null}
                    onChange={(date) => {
                        const next = date ? (toDateKey(date) ?? '') : '';
                        field.onChange(next);
                        onPlanStartDateChange?.(next);
                        onFieldsChange();
                    }}
                    disabled={disabled}
                    error={!!error}
                    hint={error?.message}
                    aria-invalid={!!error}
                />
            )}
        />
    </div>
);
